import { defineStore } from "pinia";


export const useDemoStore = defineStore("demo", {
  state: () => ({
    count: 0,
    model: {
      id: 0
    },
    arr: [{
      name: "test 1"
    }, { name: "test 2" }]
  }),
  getters: {
    getarr (state) {
      return state.arr
    }
  },
  actions: {
    getname () {
      this.arr.push({ name: "name 1" })
      this.arr.push({ name: "name 2" })
    }
  },
});
